import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { ContainerDiv } from './styles'

export default class Tags extends PureComponent {
  static propTypes = {
    tags: PropTypes.instanceOf(Array).isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: undefined
  }

  render() {
    const { tags, className } = this.props
    return (
      <ContainerDiv className={className}>
        <div className="tagsHeader">
          Теги
        </div>
        <div className="tagsSection">
          {tags.map(tag => (
            <div className="tag" key={tag}><span className="tagText">{tag}</span></div>
          ))}
        </div>
      </ContainerDiv>
    )
  }
}
